import { Badge, Flex, Text, Tooltip } from '@mantine/core';
import React from 'react';
import * as Unicons from '@iconscout/react-unicons';

interface CourseStarProps {
  rating: string;
}

const CourseStar: React.FC<CourseStarProps> = ({ rating }) => {
  return (
    <Tooltip label={rating + ' Rating'}>
      <Badge color="orange" variant="light">
        <Flex gap={4} align={'center'}>
          <Unicons.UilStar size="14" />
          <Text fz={13} fw={700}>
            {rating}
          </Text>
        </Flex>
      </Badge>
    </Tooltip>
  );
};

export default CourseStar;
